export default __webpack_public_path__ + "static/media/Autodesk-Revit-01.0346f5b5.svg";